<template>
  <div class="bg-white relative">
    <!-- also view all route commented -->
    <!-- <div
      class="absolute top-0 left-0 blur1 w-full h-full flex justify-center items-start"
    >
      <p class="sticky fsize60 sm-fsize25 top21rem">Page Coming Soon</p>
    </div> -->
    <ProductBanner />

    <div class="">
      <div class="lg:px-20 md:px-16 px-5">
        <!-- <ProductAbout /> -->
        <AllProd />
        <!-- <Help /> -->
      </div>
      <div class="bg-white lg:px-20 md:px-16 px-5"><Offer /></div>
      <!-- <div id="serviceForm"><ServiceForm /></div> -->
      <div class="lg:py-8 md:py-8 py-4 relative h-auto bg-white">
        <!-- <Membership />
        <Cards1 />
        <Cards1 /> -->
        <!-- <div
          class="absolute top-0 left-0 blur1 w-full h-fill flex justify-center items-center"
        >
          <p class="fsize60 sm-fsize25">Subscription coming soon....</p>
        </div> -->
      </div>
    </div>

    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from "../Footer.vue";
import ProductBanner from "./components/ProductBanner.vue";
import ProductAbout from "./components/ProductAbout.vue";
import AllProd from "./components/AllProd.vue";
import Help from "./components/Help.vue";
import Offer from "./components/Offer.vue";
// import Membership from "./components/Membership.vue";
import Cards1 from "../subscribe/components/Cards1.vue";
import ServiceForm from "./components/ServiceForm.vue";
import DownloadApp from "../home/components/DownloadApp.vue";

export default {
  components: {
    DownloadApp,
    ProductBanner,
    ProductAbout,
    AllProd,
    Help,
    Offer,
    // Membership,
    Footer,
    Cards1,
    ServiceForm,
  },

  mounted() {
    if (localStorage.getItem("upgrade")) {
      const getForm = document.getElementById("communityMembership");
      getForm.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    setTimeout(() => {
      if (this.$route.query["scroll"]) {
        if (this.$route.query.scroll) {
          const getForm = document.getElementById("communityMembership");

          getForm.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
      if (this.$route.query["buymembership"]) {
        if (this.$route.query.buymembership) {
          const communityMembership = document.getElementById(
            "communityMembership"
          );
          // console.log(communityMembership);
          communityMembership.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }
    }, 500);
    setTimeout(() => {
      localStorage.removeItem("upgrade");
    }, 1000);
  },
};
</script>

<style>
.blur {
  filter: blur(5px);
  -webkit-filter: blur(5px);
}
.blur1 {
  background-color: rgb(0, 0, 0);
  background-color: rgb(0, 0, 0, 0.75);
  color: white !important;

  font-weight: bold;
  z-index: 2;
  text-align: center;
}
.h-553px {
  height: 553px;
}
.fsize60 {
  font-size: 60px;
}
</style>
